// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class CoverMyMedsInboundEnrollmentHubEnrollmentModel {
    static getAttributeTypeMap() {
        return CoverMyMedsInboundEnrollmentHubEnrollmentModel.attributeTypeMap;
    }
}
CoverMyMedsInboundEnrollmentHubEnrollmentModel.discriminator = undefined;
CoverMyMedsInboundEnrollmentHubEnrollmentModel.additionalProperties = false;
CoverMyMedsInboundEnrollmentHubEnrollmentModel.attributeTypeMap = [
    {
        "name": "substitutionsAllowed",
        "baseName": "substitutionsAllowed",
        "type": "boolean"
    },
    {
        "name": "caregiver",
        "baseName": "caregiver",
        "type": "CoverMyMedsInboundEnrollmentCaregiverModel"
    },
    {
        "name": "key",
        "baseName": "key",
        "type": "string"
    },
    {
        "name": "diagnosis",
        "baseName": "diagnosis",
        "type": "string"
    },
    {
        "name": "diagnosisDate",
        "baseName": "diagnosisDate",
        "type": "string"
    },
    {
        "name": "otherDiagnosis",
        "baseName": "otherDiagnosis",
        "type": "string"
    },
    {
        "name": "drugAllergies",
        "baseName": "drugAllergies",
        "type": "string"
    },
    {
        "name": "hcpHasPreferredSpecialtyPharmacy",
        "baseName": "hcpHasPreferredSpecialtyPharmacy",
        "type": "boolean"
    },
    {
        "name": "hasPatientRepresentative",
        "baseName": "hasPatientRepresentative",
        "type": "boolean"
    },
    {
        "name": "hcpPreferredSpecialtyPharmacy",
        "baseName": "hcpPreferredSpecialtyPharmacy",
        "type": "string"
    },
    {
        "name": "isEnrollmentCopayConsented",
        "baseName": "isEnrollmentCopayConsented",
        "type": "boolean"
    },
    {
        "name": "isPrescriptionSentToSpecialtyPharmacy",
        "baseName": "isPrescriptionSentToSpecialtyPharmacy",
        "type": "boolean"
    },
    {
        "name": "isTcpaConsented",
        "baseName": "isTcpaConsented",
        "type": "boolean"
    },
    {
        "name": "medicalCardId",
        "baseName": "medicalCardId",
        "type": "string"
    },
    {
        "name": "medicalGroupId",
        "baseName": "medicalGroupId",
        "type": "string"
    },
    {
        "name": "medicalInsuranceCarrier",
        "baseName": "medicalInsuranceCarrier",
        "type": "string"
    },
    {
        "name": "noKnownDrugAllergies",
        "baseName": "noKnownDrugAllergies",
        "type": "boolean"
    },
    {
        "name": "patient",
        "baseName": "patient",
        "type": "CoverMyMedsInboundEnrollmentPatientModel"
    },
    {
        "name": "patientMarketingSignatureDate",
        "baseName": "patientMarketingSignatureDate",
        "type": "string"
    },
    {
        "name": "patientSignatureDate",
        "baseName": "patientSignatureDate",
        "type": "string"
    },
    {
        "name": "patientSignatureReceivedDate",
        "baseName": "patientSignatureReceivedDate",
        "type": "string"
    },
    {
        "name": "pdf",
        "baseName": "pdf",
        "type": "string"
    },
    {
        "name": "prescriptionDefinitions",
        "baseName": "prescriptionDefinitions",
        "type": ""
    },
    {
        "name": "preferredContact",
        "baseName": "preferredContact",
        "type": "string"
    },
    {
        "name": "preferredLang",
        "baseName": "preferredLang",
        "type": ""
    },
    {
        "name": "preferredLangOther",
        "baseName": "preferredLangOther",
        "type": "string"
    },
    {
        "name": "prescriptionBin",
        "baseName": "prescriptionBin",
        "type": "string"
    },
    {
        "name": "prescriptionGroupId",
        "baseName": "prescriptionGroupId",
        "type": "string"
    },
    {
        "name": "prescriptionInsuranceCarrier",
        "baseName": "prescriptionInsuranceCarrier",
        "type": "string"
    },
    {
        "name": "prescriptionInsurancePhone",
        "baseName": "prescriptionInsurancePhone",
        "type": "string"
    },
    {
        "name": "prescriptionMemberId",
        "baseName": "prescriptionMemberId",
        "type": "string"
    },
    {
        "name": "prescriptionPcn",
        "baseName": "prescriptionPcn",
        "type": "string"
    },
    {
        "name": "priorTherapies",
        "baseName": "priorTherapies",
        "type": "string"
    },
    {
        "name": "provider",
        "baseName": "provider",
        "type": "CoverMyMedsInboundEnrollmentProviderModel"
    },
    {
        "name": "providerSignatureDate",
        "baseName": "providerSignatureDate",
        "type": "string"
    },
    {
        "name": "samplePackProvidedDate",
        "baseName": "samplePackProvidedDate",
        "type": "string"
    },
    {
        "name": "secondaryMedicalCardId",
        "baseName": "secondaryMedicalCardId",
        "type": "string"
    },
    {
        "name": "secondaryMedicalGroupId",
        "baseName": "secondaryMedicalGroupId",
        "type": "string"
    },
    {
        "name": "secondaryMedicalInsuranceCarrier",
        "baseName": "secondaryMedicalInsuranceCarrier",
        "type": "string"
    },
];
//# sourceMappingURL=coverMyMedsInboundEnrollmentHubEnrollmentModel.js.map